import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaasInvoiceManageService {
   prefix: string = environment.saasWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {}

  //查询列表
  queryPageList(param) {
    const url = this.prefix + 'invoice/queryPageList';
    return this.http.Post(url, param);
  }

  //查看
  queryById(param) {
    const url = this.prefix + 'invoice/queryById';
    return this.http.Post(url, param);
  }

  //审核
  verifyById(param) {
    const url = this.prefix + 'invoice/approve';
    return this.http.Post(url, param);
  }
}
